import getApiClient from '../../../../../plugins/api'

export default {
    setGender: function(gender) {
        this.user.gender = gender
    },

    loadData: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')

        let userId = self.$store.state.user.id

        api.get(`/user/${userId}`)
            .then(result => {
                self.user = Object.assign({}, result.data)
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    }
}
